import React from "react";
import MainHeading from "../../MainHeading/MainHeading";
import WebsiteHeading from "../../WebsiteHeading/WebsiteHeading";
import NotFoundBlock from "../NotFoundBlock/NotFoundBlock";
import RedirectButton from "../RedirectButton./RedirectButton";

const Body = (props) => {
  return (
    <div className="w-full mt-12 flex flex-col justify-center">
      <MainHeading heading="Check Results" />
      <WebsiteHeading {...props} />
      <NotFoundBlock />
      <RedirectButton {...props} />
    </div>
  );
};

export default Body;
